/** @format */

import React, { useState } from 'react'
import { _$, Card } from '@king-design/react'
import styled from 'styled-components'
import { CustomPageContainer } from 'src/components'
import { initSearch } from '../components/constant'
import { ServiceOverviewSearchProps } from '../components/typescript'
import HeaderFilter from '../components/HeaderFilter'
import TraceContainer from './container'
import useNavRegion from 'src/hooks/useNavRegion'
const TraceAnalysis: React.FC<{ className?: string }> = ({ className }) => {
  const [headerSearch, setHeaderSearch] = useState<ServiceOverviewSearchProps>(initSearch())
  const region = useNavRegion()
  return (
    <div className={className}>
      <CustomPageContainer title={_$('Trace分析')}>
        <Card type="none">
          <HeaderFilter value={headerSearch} onChange={setHeaderSearch} showAggregate={false} />
          <div className="trace-analysis-container">
            <TraceContainer region={region} headerSearch={headerSearch} />
          </div>
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(TraceAnalysis)`
  .trace-analysis-container {
    margin-top: 16px;
  }
`
